import { Config } from "./Config";
import { ConfigLogic } from "./ConfigLogic";

/** This file assigns config to global salaxy namespace. */
declare const globalThis;
/** This file assigns config to global salaxy namespace. */
declare const global;

/**
 * Class for reading Environment specific configuration for Salaxy API's and JavaScript in general
 */
export class Configs {

  private static get defaultConfig() {
    return {
      wwwServer: "https://test.palkkaus.fi",
      apiServer: "https://test-api.salaxy.com",
      proServer: "https://demo-pro.palkkaus.fi/server",
      reportServer: "https://test-reports.salaxy.com",
      integrationsServer: "https://test-integrations.salaxy.com",
      isTestData: true,
      useCookie: true,
    };
  }

  private static getGlobalConfig(): Config {
    const g = this.getGlobal();
    return (g.salaxy && g.salaxy.config) ? g.salaxy.config : null;
  }

  private static setGlobalConfig(config: Config) {
    const g = this.getGlobal();
    g.salaxy = g.salaxy || {};
    g.salaxy.config = config;
  }

  private static getGlobal(): any {
    if (typeof globalThis !== "undefined") { return globalThis; }
    if (typeof self !== "undefined") { return self; }
    if (typeof window !== "undefined") { return window; }
    if (typeof global !== "undefined") { return global; }
    throw new Error("unable to locate global object");
  }

  /**
   * Returns current configuration.
   * If global (salaxy.config) configuration is null, default config (demo) is returned
   */
  public static get current(): ConfigLogic {
    return new ConfigLogic(this.getGlobalConfig() ?? this.defaultConfig);
  }

  /**
   * Set current configuration.
   */
  public static set current(config: Config) {
    this.setGlobalConfig(config);
  }

  /** Get global, globalThis object */
  public static get global(): any {
    return this.getGlobal();
  }
}
